// Importaciones necesarias
import React, { useEffect } from 'react';

import styles from './styles';
import { makeStyles } from '@mui/styles';
import { Dashboard as DashboarLayout } from 'layouts';
import { useDispatch, useSelector } from 'react-redux';
import { deleteRole, showRoles } from 'js/actions/roleActions';
import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { Box } from '@mui/material';
import { getColumns } from './columns';
import { useIntl } from 'react-intl';
import Swal from 'sweetalert2';
const useStyles = makeStyles(styles);
// Estilos con Material UI
// ==================== Componentes ======================
// Componente funcional para la barra de búsqueda rápida.
// Recibe las props y retorna la barra de búsqueda.
// Componente para la barra de búsqueda rápida en el toolbar
function QuickSearchToolbar() {
  return (
    <Box
      sx={{
        p: 2,
        display: 'flex',
        justifyContent: 'flex-end', // Alinea el filtro a la derecha
      }}
    >
      <GridToolbarQuickFilter /> {/* Barra de búsqueda rápida para la tabla */}
    </Box>
  );
}

// Componente principal para la lista de roles.
export default function RolesList() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const intl = useIntl();
  const { roles } = useSelector((state) => state.roles);
  const { user } = useSelector((state) => state.user);

  // Efecto para cargar los roles al montar el componente.
  useEffect(() => {
    dispatch(showRoles());
  }, []);

  // Función para manejar la eliminación de un usuario (no implementada).
  const handleDeleteUser = (role) => {
    // Muestra un cuadro de confirmación antes de borrar al usuario
    Swal.fire({
      title: `${intl.formatMessage({ id: 'app.groupsCards.deleteGroupBtn.title' })} `,
      text: `${intl.formatMessage({ id: 'app.groupsCards.deleteGroupBtn.text' })} ${role.name}`,
      icon: 'warning',
      showCancelButton: true, // Muestra botón de cancelación
      confirmButtonText: intl.formatMessage({
        id: 'app.groupsCards.deleteGroupBtn.confirmation',
      }),
    }).then((result) => {
      if (result.value) {
        // Si el usuario confirma, se elimina
        Swal.fire({
          title: intl.formatMessage({
            id: 'app.groupsCards.deleteGroupBtn.titleConfirmation',
          }),
          text: intl.formatMessage({
            id: 'app.groupsCards.deleteGroupBtn.textConfirmation',
          }),
          icon: 'success', // Mensaje de éxito
        });
        dispatch(deleteRole(role)); // Llama la acción de Redux para eliminar al role
      }
    });
  };

  // Función para mostrar los detalles de un rol en una alerta.
  // Recibe los datos del rol como argumento.
  // Extrae las descripciones de los permisos y las muestra en una alerta.
  // Usa SweetAlert2 para mostrar la alerta.
  const displayRoleDetail = (roleData) => {
    // Extraer las descripciones de los permisos
    const permissionsDescriptions = roleData.permissions
      .map((permission) => permission.description)
      .join(', ');

    // Mostrar los detalles del rol con las descripciones de los permisos en la alerta
    Swal.fire({
      title: roleData.name, // Título con el nombre del rol
      text: `Permisos: ${permissionsDescriptions}`, // Texto con las descripciones de los permisos
      icon: 'info', // Tipo de icono
    });
  };

  // Obtiene las columnas para la tabla, pasando la información internacionalizada,
  // el usuario actual, la función para eliminar usuarios y la función para mostrar detalles.
  const columns = getColumns(intl, user, handleDeleteUser, displayRoleDetail);

  return (
    <DashboarLayout title="Roles">
      <div className={classes.root}>
        <div className={classes.content}>
          <DataGrid
            // Columnas de la tabla
            columns={columns}
            // Filas con la lista de roles
            rows={roles}
            // Deshabilitar la seleccion de filas
            rowSelection={false}
            // Configuración de tabla
            initialState={{
              ...roles.initialState, // Estado inicial de la tabla
              pagination: {
                ...roles.initialState?.pagination,
                paginationModel: {
                  pageSize: 5, // Tamaño de la página
                },
              },
            }}
            slots={{ toolbar: QuickSearchToolbar }} // Usa el componente QuickSearchToolbar para la barra de búsqueda
            sx={{
              pt: 2,
              pb: 2,
              borderRadius: 2,
              boxShadow: 3,
              backgroundColor: 'background.paper', // Color de fondo de la tabla
              border: '1px solid',
              borderColor: 'divider',
              '& .MuiDataGrid-root': {
                border: 'none', // Quitar borde de la tabla
              },
              '& .MuiDataGrid-cell': {
                borderBottom: '1px solid rgba(224, 224, 224, 1)', // Borde inferior de las celdas
                maxHeight: '60px', // Altura máxima de las celdas
              },
              '& .MuiDataGrid-columnHeaders': {
                borderBottom: '1px solid rgb(199, 199, 199)', // Borde inferior de los encabezados de columna
              },
              '& .MuiDataGrid-row': {
                borderBottom: '1px solid rgb(199, 199, 199)', // Borde inferior de las filas
                maxHeight: '60px', // Altura máxima de las filas
              },
            }}
          />
        </div>
      </div>
    </DashboarLayout>
  );
}
